<!--
 * @Description: 流程审批主体、发起流程和流程审批的几个主要组件
 * @Author: wangwangwang
 * @Date: 2020-11-26 13:50:09
 * @LastEditors: 刘小二
 * @LastEditTime: 2025-12-31 11:35:21
-->
<template>
  <section v-loading="loading">
    <FlowsNodeList v-if="readOnly" :tableData="approveTableData" />
    <approvalModal v-if="approvalVisible" :approvalVisible='approvalVisible' :approvalNode='approvalNode'
      @sendApprovePerson="sendApprovePerson" @handleModal="handleModal" />
    <!-- 流程审批操作 -->
    <Flowbackup v-if="backVisible" :visible="backVisible" :tableData="backTableData" @closeModel="backVisible = false"
      @hanldeSure='hanldeSure' />
    <HandleNode ref="HandleNode" :visible='nodeVisible' :sendTable="approveTableData" @hanldeClose="nodeVisible = false"
      @hanldeSure="hanldeSure2" />
    <OperationModal v-if="showSendVisible" ref="OperationModal"  :showSendVisible="showSendVisible" @handleSure="handleSend"
      @handleCancel="handleCancel" />
    <FlowMap v-if="mapVisible" :visible='mapVisible' :nodeDataSource="allNode" :originalNodeList="originalNodeList"
      :processNodeList="processNodeList" :nodeTableData="nodeTableData" @closeModel="mapVisible = false" />
    <personModel v-if="visible" :title="handleTitle" :visible='visible' :isFlow="true" @closeModel='visible = false'
      @getPerson='getPerson' />
  </section>
</template>
<script>
import FlowsNodeList from '@/components/WorkFlow/flowsNodeList';
import approvalModal from '@/components/WorkFlow/approvalModal';
import OperationModal from '@/components/WorkFlow/OperationModal';
import FlowMap from '@/components/WorkFlow/flowMap';
import personModel from '@/components/ChoisePerson/personModel';
import Flowbackup from '@/components/WorkFlow/flowbackup';
import HandleNode from '@/components/WorkFlow/handleNode';
import { taskCollectByUser } from '@/api/task/taskType';
import { getNodeList, submitApproval, beforeSubmitApproval, submitTask,updateTaskUrl, saveWorkFlow, previewProcess, getFlowsCode, addApprover, setCCAction, assignmentApprover, backPrefixNode, cancelTask, submitTaskProcess, getFirstLastForm, getForm, getProcessNodeBaseVoListByCodes, getNodeData } from '@/api/task/flows';
import addTab from "@/common/addTab.js";
import { getUserId } from '@/utils/auth.js';
export default {
  props: {
    code: {
      default: '' // 默认为空字符串，可根据实际场景改（如 null/0 等）
    },
    urlType: {
      default: 2 // 默认为空字符串，可根据实际场景改（如 null/0 等）
    },
    dataForm: {
      default() { // 引用类型（对象/数组）必须用函数返回默认值，避免复用同一引用
        return {}
      }
    },
    title: {
      default: ''
    },
    showSendVisible: {
      default: false // 布尔类型默认值
    }
  },
  components: {
    approvalModal,
    OperationModal,
    FlowsNodeList,
    FlowMap,
    personModel,
    Flowbackup,
    HandleNode,
  },
  data() {
    return {
      loading: false,
      approvalVisible: false,
      mapVisible: false,
      visible: false,
      backVisible: false,
      nodeVisible: false,
      approveTableData: [],
      approvalNode: [],
      flowsBaseInfo: {},
      readOnly: false,
      sendPerson: '',
      dataSource: [],
      processManagerId: '',
      billCode: '',
      formData: {},
      allNode: [],
      originalNodeList: [],
      processNodeList: [],
      showNodeList: [],
      nodeidStr: [],
      nodeTableData: [],
      backTableData: [],
      handleTitle: '',
      handleType: '',
      subordinateSystem: '',
      limiSend: false,
      isFinalSubmission: false,
      processInstanceApprovalVo: "",
      SCMUser: [],
      processVersionId: '',
      // sendVisible: false   // 将审批意见对话框的状态缓存，增加中间处理逻辑
    }
  },
  methods: {
    //设置默认审批意见
    setOperationModal(approvalOptions){
      this.$refs.OperationModal.setOperationModal(approvalOptions)
    },
    initBaseData(code) {
      const { query } = this.$route;
      // 获取流程编码
      getFlowsCode({ code }).then(res => {
        if (res.code === 1001) {
          this.$emit('sendCode', res.data.code);
          this.billCode = res.data.code;
          this.processManagerId = res.data.processManagerId;
          this.subordinateSystem = res.data.systemName;
          this.$emit('sendProcessManagerId', res.data.processManagerId);
          if (query.type * 1 === 1) {
            getFirstLastForm({ processManagerId: res.data.processManagerId, processVersionId: "", nodeType: 1 }).then(res => {
              console.log(res);
              this.$emit('getSCMUser', res.data[0].formColumnData);
              this.$emit('sendProcessVersionId', res.data[0].processVersionId);
            })
          }
        }
      })
    },
    handleModal(type, isState) {
      if (type === 1) { // 关闭弹窗
        this.approvalVisible = false;
      } else { // 提交流程
        this.handleSure(isState);
      }
    },
    handleSure(isState) {
      var _this = this
      const { query } = this.$route;
      const nodeList = this.approvalNode.map((item) => {
        if (item.personList) {
          const newArry = item.personList.map((items) => {
            return {
              organization: '',
              station: '',
              userId: items.id,
              userName: items.name,
            }
          })
          return {
            ...item,
            userSet: newArry
          }
        } else {
          return item
        }
      });
      for (let i = 0; i < nodeList.length; i += 1) {
        if (!nodeList[i]?.userSet?.length) {
          this.$message({
            type: 'warning',
            message: `请选择节点序号为${i}的审批人`,
          })
          return
        }
      }
      const params = {
        nodeList,
        processManagerId: this.processManagerId || query.processManagerId, // 待发任务时数据从连接上获取,
        formType: '2',
        processTaskId: this.processTaskId,
      }
      if (this.limiSend) {
        return
      }
      this.limiSend = true
      if (isState) {
        submitTaskProcess({ processManagerInstanceVo: params, processInstanceApprovalVo: this.processInstanceApprovalVo }).then(res => {
          this.limiSend = false
          if (res.code === 1001) {
            this.approvalVisible = false
            this.showSendVisible = true
          }
        });
      } else {
        params.pageUrl = this.setPageUrl(1);
        updateTaskUrl({receiptNumber:this.billCode || query.receiptNumber,content:this.setPageUrl(2)})
        submitTask(params).then(res => {
          this.limiSend = false
          if (res.code === 1001) {
            this.$message({
              type: 'success',
              message: '流程提交成功！！！'
            });
            console.log('---------------------------')
            _this.$emit('changeAudio', 2);
            this.$emit('handleFinish', 1, this.processTaskId)
            this.approvalVisible = false;
            this.$emit('submitData')
            addTab.$emit("remove", this.$route.name);

          }
        });
      }
    },
    processBefore(data) {
      this.processInstanceApprovalVo = ""
      const newData = this.approveTableData.find((item) => item.approvalStatus === 1);
      if (!newData || !newData.processInstanceNodeId) {
        this.$message.warning('未找到当前审批节点');
        return
      }
      // 保障节点ID是字符串，而不是数组
      let nodeId = newData.processInstanceNodeId
      if (typeof nodeId === 'object') {
        nodeId = nodeId[0]
      }
      console.log(this)
      const params = {
        processInstanceId: newData.processInstanceId,
        processInstanceNodeId: Array.isArray(newData.processInstanceNodeId) ? newData.processInstanceNodeId[0] : newData.processInstanceNodeId,
        callbackData: JSON.stringify(data),
      }
      this.processInstanceApprovalVo = params;
      beforeSubmitApproval(params).then(res => {
        if (res.code === 1001) {
          if (res.data && res.data.nodeList && res.data.nodeList.length != 0) {
            this.approvalNode = res.data.nodeList
            this.approvalNode = res.data.nodeList.map((item) => {
              if (item?.userSet?.length) {
                return {
                  ...item,
                  showName: (item.userSet.map((item) => item.userName)).join(',',),
                }
              } else {
                return item
              }
            });
            this.approvalNode.isFirstBtn = true;
            this.approvalVisible = true
          } else {
            this.showSendVisible = true
          }
        }
      })
    },
    // 善建云通参数 type 1为善建云通  2为pcURL
    setPageUrl(type) {
      const { query } = this.$route;
      console.log(`-----------------------------------this.dataForm.createTime->`, this.dataForm.createTime)
      console.log(`-----------------------------------this.dataForm.createUserName->`, this.dataForm.createUserName)
      //debtControlLevelOld 风控 申请解控等级参数  quantityDifferenceId 过程量差id
      let dataContent = { id: this.dataForm.id || this.dataForm.quantityDifferenceId, debtControlLevelOld: this.dataForm.debtControlLevelOld, processManagerId: this.dataForm.processManagerId, processTaskId: this.dataForm.processTaskId, processVersionId: this.dataForm.processVersionId, receiptNumber: this.dataForm.receiptNumber }
      let url = type == 1 ? 'h5/#/' + this.$route.name + '?' : '#' + this.$route.path + '?'
        let urlAdd = 'processManagerId=' + (this.processManagerId || query.processManagerId)
        + '&processTaskId=' + (this.processTaskId || query.processTaskId)
        + '&processVersionId=' + (this.processVersionId || query.processVersionId)
        + '&receiptNumber=' + (this.billCode || query.receiptNumber)
        + '&dataContent=' + JSON.stringify(dataContent)
        + '&createUserName=' + (this.dataForm.createUserName || query.createUserName)
        + '&createTime=' + (this.dataForm.createTime || query.createTime)
        + '&taskName=' + this.title
        + '&taskType=1'
        + '&taskStatus=2'
        + '&type=2&isReadOnly=0'
        let urlAll = url + encodeURI(urlAdd)
      return urlAll
    },
    /**
     * @Description: 流程接收业务数据  进行操作
     * @Param: 
     * @Author: wangwangwang
     */
    handleToFlow(data) {
      const newData = this.approveTableData.find((item) => item.approvalStatus === 1);
      if (!newData || !newData.processInstanceNodeId) {
        this.$message.warning('未找到当前审批节点');
        return
      }
      // 保障节点ID是字符串，而不是数组
      let nodeId = newData.processInstanceNodeId
      if (typeof nodeId === 'object') {
        nodeId = nodeId[0]
      }

      const params = {
        approvalOptions: this.formData.approvalOptions,
        approvalStatus: this.formData.approvalStatus,
        processInstanceId: newData.processInstanceId,
        processInstanceNodeId: Array.isArray(newData.processInstanceNodeId) ? newData.processInstanceNodeId[0] : newData.processInstanceNodeId,
        callbackData: JSON.stringify(data),
        pageUrl: this.setPageUrl(1),
      }
      const { query } = this.$route;
      updateTaskUrl({receiptNumber:this.billCode || query.receiptNumber,content:this.setPageUrl(2)})
      submitApproval(params).then(res => {
        if (res.code === 1001) {
          this.$message.success('提交成功');
          /**
           * @Description: 如果是最后一个就调授权的接口
           * @Param: process_failure：表示失败
           * @Author: wangwangwang
           */
          // if (res.data?.processResult === 'process_success') {
          //   this.$emit('handleFinish', 2, this.formData.approvalStatus)
          // } else if(res.data?.processResult === 'process_failure'){
          //   this.$emit('handleFinish', 2, this.formData.approvalStatus)
          // } else if(res.data?.processResult === 'process_ing'){
          //   this.$emit('handleFinish', 2, this.formData.approvalStatus)
          // }

          if (res.data.processResult == 'process_ing') {
            this.$emit('handleFinish', 3, this.formData.approvalStatus)
          } else {
            this.$emit('handleFinish', 2, this.formData.approvalStatus)
          }
          addTab.$emit("remove", this.$route.name);
          console.log('--------------------------------------------------------这里的提交')
          if (res.data.processResult == 'process_failure') {
            this.$emit('changeAudio', 4)
          } else {
            this.$emit('changeAudio', 3)
          }
        }
      })
      // console.log(101, params, newData.processInstanceNodeId)
    },
    /**
     * @Description: 父组件传值过来保存数据
     * @Param: 
     * @Author: wangwangwang
     */
    saveFlows(type, data, flowsType) {
      if (flowsType * 1 === 10) { // 强制编辑
        this.editTask(data);
      } else if (type === 1) { // 保存
        this.saveTask(data, flowsType);
      } else if (type === 2) { // 提交
        this.sendTask(data, flowsType);
      } else if (type === 3) { // 撤销
        this.handleBackEnd(data);
      } else if (type === 4) { // 抄送
        this.visible = true;
        this.handleType = 1;
        this.handleTitle = '选择抄送人员'
      } else if (type === 5) { // 交办
        this.visible = true;
        this.handleType = 3;
        this.handleTitle = '选择交办人员'
      } else if (type === 6) { // 回退
        this.backTableData = this.approveTableData.filter(item => item.approvalStatus === 2);
        this.backVisible = true;
      } else if (type === 7) { // 协审
        this.visible = true;
        this.handleType = 2;
        this.handleTitle = '选择协审人员'
      } else if (type === 8) { // 加减签
        this.nodeVisible = true;

      } else if (type === 9) { // 流程图
        this.showNodeImage();
      } else if (type === 10) { // 收藏任务
        this.handleCollection();
      }
    },
    editTask(data) {
      const { query } = this.$route;
      if (!this.title) {
        this.$message.warning('流程标题为空，请输入标题');
        return
      }
      const params = {
        taskType: 1,
        formType: 2,
        taskStatus: 3,
        subordinateSystem: this.subordinateSystem,
        processManagerId: this.processManagerId || query.processManagerId, // 待发任务时数据从连接上获取
        receiptNumber: this.billCode || query.receiptNumber, // 待发任务时数据从连接上获取
        taskName: this.title,
        field1: this.setPageUrl(2),
        field2: this.urlType == 1 ? 1 : 2, // urlType 1pc2移动
        ...data,
      }
      saveWorkFlow(params).then(res => {
        if (res.code === 1001) {
          this.$message.success('强制编辑成功');
          addTab.$emit("remove", this.$route.name);
        }
      });
    },
    saveTask(data, saveTask) {
      const { query } = this.$route;
      if (!this.title) {
        this.$message.warning('流程标题为空，请输入标题');
        return
      }
      if (!(this.processManagerId || query.processManagerId)) {
        this.$message.warning('未获取到流程信息，请关闭菜单后重新发起!!!');
        return
      }
      const params = {
        taskType: saveTask ? 2 : 1,
        formType: 2,
        subordinateSystem: this.subordinateSystem,
        taskStatus: saveTask ? '' : 1,
        processManagerId: this.processManagerId || query.processManagerId, // 待发任务时数据从连接上获取
        receiptNumber: this.billCode || query.receiptNumber, // 待发任务时数据从连接上获取
        taskName: this.title,
        field1: this.setPageUrl(2),
        field2: this.urlType == 1 ? 1 : 2, // urlType 1pc2移动
        ...data,
      }
      if (!(this.billCode || query.receiptNumber)) {
        this.$message.warning('单据编号为空，请稍等或刷新');
        return
      }
      saveWorkFlow(params).then(res => {
        if (res.code === 1001) {
          this.processTaskId = res.data;
          this.$store.dispatch("setProcessTaskId", res.data);
          if (!saveTask) {
            this.$message.success('保存成功');
          }
        }
      });
    },
    sendTask(data, saveTask) {
      const { query } = this.$route;
      if (!this.title) {
        this.$message.warning('流程标题为空，请输入标题');
        return
      }
      if (!(this.billCode || query.receiptNumber)) {
        this.$message.warning('单据编号为空，请稍等或刷新');
        return
      }
      const params = {
        taskType: saveTask ? 2 : 1,
        formType: 2,
        taskStatus: 1,
        processManagerId: this.processManagerId || query.processManagerId, // 待发任务时数据从连接上获取
        receiptNumber: this.billCode || query.receiptNumber, // 待发任务时数据从连接上获取
        taskName: this.title,
        field1: this.setPageUrl(2),
        field2: this.urlType == 1 ? 1 : 2, // urlType 1pc2移动
        ...data,
      }
      saveWorkFlow(params).then(res => {
        if (res.code === 1001) {
          this.processTaskId = res.data;
          this.$store.dispatch("setProcessTaskId", res.data);
          this.showApprovePerson(data);
        }
      });
    },
    /* 
    * 生成流程图中的数据(allNode)中没有processNodeId，只能通过接口转换获取
    * 在把转换的id (节点id), userName（节点处理人）赋给流程图的数据(allNode)
    */
    showNodeId(item) {
      this.processNodeList.forEach(item2 => {
        if (item.nodeId == item2.code) {
          for (let i = 0; i < this.originalNodeList.length; i++) {
            if (this.originalNodeList[i].processNodeId == item2.id) {
              item.userName = this.originalNodeList[i].instanceLogsList[0].userName
              item.id = item2.id
              if (item.id == this.originalNodeList[i].processNodeId) {
                item.approvalStatus = this.originalNodeList[i].approvalStatus
                this.originalNodeList.forEach(e => { // 当前节点是唯一的
                  if (e.approvalStatus == 1 && item.id == e.processNodeId) {
                    item.approvalStatus = 1
                  }
                })
              }
              // console.log(this.originalNodeList[i]);
            }
          }
        }
      })
      return item;
    },
    showNodeId2(arr) {
      arr.forEach(item => {
        if (item.childNode) {
          item.childNode = this.showNodeId2(item.childNode);
        }
        item = this.showNodeId(item);
      })
      return arr
    },
    showNodeImage() {
      this.mapVisible = true;
      this.showNodeId2(this.allNode);
    },
    handleCollection() {
      const { query } = this.$route;
      const params = [{ receiptNumber: this.billCode || query.receiptNumber }]
      taskCollectByUser(params).then(res => {
        if (res.code === 1001) {
          this.$message.success('收藏成功');
        }
      })
    },
    showApprovePerson(data) {
      const { query } = this.$route;
      let content = '{}'
      if (data && data.dataContent) {
        content = JSON.parse(data.dataContent)
      }
      console.log(data, 1234)
      const params = {
        processManagerId: this.processManagerId || query.processManagerId, // 待发任务时数据从连接上获取
        processTaskContent: JSON.stringify(content.formData || content || {})
      }
      previewProcess(params).then(res => {
        if (res.code === 1001) {
          this.processVersionId = res.data.processVersionId;
          this.approvalNode = res.data.nodeList.map((item) => {
            if (item?.userSet?.length) {
              return {
                ...item,
                showName: (item.userSet.map((item) => item.userName)).join(',',),
              }
            } else {
              return item
            }
          });
          this.approvalVisible = true;
        }
      })
    },
    sendApprovePerson(choisePerson, index) {
      const data = {
        showName: (choisePerson.map((item) => item.name)).join(','),
      }
      const newArry = this.approvalNode.map((item, idx) => {
        if (index === idx) {
          return {
            ...item,
            ...data,
            personList: choisePerson,
          }
        } else {
          return item
        }
      })
      this.approvalNode = newArry;
    },
    initBusiness() {
      const { query } = this.$route;
      this.dataContent = JSON.parse(query.dataContent);
      this.readOnly = true;
      /**
      * @Description: 获取流程节点信息
      * @Param: 
      * @Author: wangwangwang
      */
      const params = {
        processManagerId: query.processManagerId,
        processTaskId: query.processTaskId,
        processVersionId: query.processVersionId,
        receiptNumber: query.receiptNumber,
      }
      // 获取所有节点
      getNodeList(params).then(res => {
        this.loading = true
        if (res.code === 1001) {
          this.originalNodeList = JSON.parse(JSON.stringify(res.data));
          const newData = [];
          res.data.forEach(item => {
            const data = {
              nodeName: item.nodeName,
              userName: item.instanceLogsList.map(sItem => sItem.userName),
              userId: item.instanceLogsList.map(sItem => sItem.userId),
              multiApprovalType: item.multiApprovalType,
              approvalOptions: item.instanceLogsList.map(sItem => sItem.approvalOptions),
              handlerTime: item.instanceLogsList.map(sItem => sItem.handlerTime),
              id: item.id,
              approvalStatus: item.approvalStatus,
              processInstanceId: item.processInstanceId,
              processInstanceNodeId: item.instanceLogsList.map(sItem => sItem.processInstanceNodeId),
            }
            newData.push(data);
          });
          this.$emit('sendNodeList', res.data);
          const firstPerson = res.data[0].instanceLogsList[0].userId;
          this.$store.dispatch("user/setFlowsId", firstPerson);
          this.approveTableData = newData;
          this.isFinalSubmission = false
          this.loading = false
          let nowNode = (res.data.filter(item => item.nodeType == 3 && item.approvalStatus === 1))[0]
          let endNode = (res.data.filter(item => item.nodeType == 2))[0]
          if (nowNode.nextNodeIds == endNode.id) {
            this.isFinalSubmission = true
          }
          this.$emit('lastSub', this.isFinalSubmission)
          // 判断是否是最后提交审核的节点
          for (let i = 0; i < res.data.length; i += 1) {
            if (res.data[i].approvalStatus === 1) {
              let getFormParams = {
                processManagerId: query.processManagerId,
                processVersionId: query.processVersionId,
                processNodeId: res.data[i].processNodeId
              }
              // 获取SCM权限
              if (res.data[i].processNodeId) {
                getForm(getFormParams).then(res => {
                  this.SCMUser = JSON.parse(res.data.formColumnData)
                  this.nodeTableData = JSON.parse(res.data.formColumnData)
                  this.$emit('getSCMUser', res.data.formColumnData);
                })
              } else {
                getFirstLastForm({ processManagerId: query.processManagerId, processVersionId: "", nodeType: 1 }).then(res => {
                  this.nodeTableData = JSON.parse(res.data.formColumnData)
                  this.$emit('getSCMUser', res.data.formColumnData);
                })
              }
              if (res.data[i].formColumnData) {
                this.$emit('setElement', JSON.parse(res.data[i].formColumnData));
                return
              }
            }
            if (query.taskType * 1 === 5) {
              for (let j = 0; j < res.data[i]?.instanceLogsList.length; j += 1) {
                if (getUserId() === res.data[i].instanceLogsList[j].userId && res.data[i].formColumnData) {
                  this.$emit('setElement', JSON.parse(res.data[i].formColumnData));
                }
              }
            }
          }
        }
      });
      // 请求节点
      getNodeData({ processManagerId: query.processManagerId, processVersionId: query.processVersionId }).then(res => {
        const arr = JSON.parse(res.data.processData)
        this.$nextTick(() => {
          this.allNode = JSON.parse(res.data.processData)
        })
        this.nodeidStr = [];
        this.getNodeId(arr);

        const params = {
          processManagerId: res.data.processManagerId,
          processVersionId: res.data.processVersionId,
          codeList: this.nodeidStr.toString()
        }
        getProcessNodeBaseVoListByCodes(params).then(res2 => {
          this.processNodeList = res2.data;
        })
      })
    },
    getNodeId(arr) {
      arr.forEach(item => {
        if (item.childNode) {
          this.getNodeId(item.childNode);
        }
        this.nodeidStr.push(item.nodeId);
      })
    },
    // 审批窗口：确定
    handleSend(formData) {
      this.formData = formData;
      if (formData.approvalStatus === '3') {
        // 不同意
        this.$emit('resetFlowState', 1);
      } else {
        // 提交审批
        this.$emit('handleBusiness', formData);
      }
    },
    // 审批窗口：取消
    handleCancel() {
      this.showSendVisible = false
      this.$emit('handleCancel');
    },
    hanldeSure(data) {
      console.log(data);
      const newData = this.approveTableData.find((item) => item.approvalStatus === 1);
      if (!newData.processInstanceNodeId) {
        this.$message.warning('未找到当前审批节点');
        return
      }
      const params = {
        sourceNodeId: Array.isArray(newData.processInstanceNodeId) ? newData.processInstanceNodeId[0] : newData.processInstanceNodeId,
        targetNodeId: data.id,
        remarks: data.remarks,
      }
      backPrefixNode(params).then(res => {
        if (res.code === 1001) {
          this.$message.success('回退成功');
          addTab.$emit("remove", this.$route.name);
        }
      })
    },
    /**
     * @Description: 加减签
     * @Param: 通过对比进行判断
     * @Author: wangwangwang
     * @param {*} data
     */
    hanldeSure2(data) {
      const allHasData = this.approveTableData.filter(item => data.some(items => (items.userId === item.userId && items.processInstanceId === item.processInstanceId)));
      const deleteData = this.approveTableData.filter(item => !allHasData.some(items => (items.userId === item.userId && items.processInstanceId === item.processInstanceId)));
      const addData = data.filter(item => !allHasData.some(items => (items.userId === item.userId && items.processInstanceId === item.processInstanceId)));
      const params = addData.concat(deleteData.map(item => ({ ...item, status: 0 })));
      addApprover(params).then(res => {
        if (res.code === 1001) {
          this.$message.success('操作成功！！！');
          this.nodeVisible = false;
        }
      })
    },
    getPerson(data) {
      // const newData = this.approveTableData.find((item) => item.approvalStatus === 1);
      // console.log('选人后返回数据:', data, this.$route.query)
      const { query } = this.$route
      // if (!newData || !newData.processInstanceNodeId) {
      //   this.$message.warning('未找到当前审批节点');
      //   return
      // }
      if (this.handleType === 1) { // 抄送
        const params = data.map(item => ({ userId: item.id, userType: 3, userName: item.name, processInstanceId: query.processInstanceId, processInstanceNodeId: query.processInstanceNodeId }))
        setCCAction(params).then(res => {
          if (res.code === 1001) {
            this.$message.success('抄送成功！！！');
            this.visible = false;
          }
        })
      }
      if (this.handleType === 2) { // 协审
        const params = data.map(item => ({ userId: item.id, userType: 2, userName: item.name, processInstanceId: query.processInstanceId, processInstanceNodeId: query.processInstanceNodeId }))
        addApprover(params).then(res => {
          if (res.code === 1001) {
            this.$message.success('添加协审成功！！！');
            this.visible = false;
          }
        })
      }
      if (this.handleType === 3) { // 交办
        if (data.length > 1) {
          this.$message.warning('交办人员不能大于1位');
          return
        }
        let nodeId = query.processInstanceNodeId
        if (typeof query.processInstanceNodeId === 'object') {
          nodeId = query.processInstanceNodeId[0]
        }
        const params = {
          processInstanceNodeId: nodeId,
          userIds: data[0].id,
          userName: data[0].name,
        }
        assignmentApprover(params).then(res => {
          if (res.code === 1001) {
            this.visible = false;
            this.$message.success('交办成功！！！');
            setTimeout(() => {
              addTab.$emit("remove", this.$route.name);
            }, 1000)
          }
        })
      }
    },
    handleBackEnd(data) {
      const { query } = this.$route;
      this.$confirm('确定撤销此流程?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        cancelButtonClass: 'bottom_all_two',
        confirmButtonClass: 'bottom_all',
        type: 'warning'
      }).then(() => {
        const params = {
          taskId: query.processTaskId,
        }
        cancelTask(params).then(res => {
          if (res.code === 1001) {
            this.$emit('resetFlowState', 2);
            this.$message.success('撤销成功', 1, () => {
              this.$emit('resetFlowState', 2);
              addTab.$emit("remove", this.$route.name);
            });
            console.log(data)
            // cancelTask2(data)
          }
        })
      }).catch(() => {
      });
    }
  },
  mounted() {
    /**
     * @Description: 流程审批用户回显流程相关数据、发起流程不调用此方法
     * @Param: 
     * @Author: wangwangwang
     */
    const { query } = this.$route;
    if (query.type * 1 === 2 && query.taskType * 1 !== 2) {
      this.initBusiness();
    }
    if (query.type * 1 === 2 && !query.processVersionId) {
      getFirstLastForm({ processManagerId: query.processManagerId, processVersionId: "", nodeType: 1 }).then(res => {
        this.$emit('getSCMUser', res.data[0].formColumnData);
      })
    }
    this.$store.dispatch("setProcessTaskId", '');
  }
}
</script>
<style scoped></style>
